import { SocketSlice } from "./types"
import { UserLocation, StoppedBroadcastingLocation } from "@nova/schemas"
import { userLocationStore } from "features/user-locations/user-location-store"

export default {
    events: {
        userLocationUpdated: () => (payload: UserLocation) => {
            userLocationStore.push(payload)
        },
        stoppedBroadcastingLocation: () => (payload: StoppedBroadcastingLocation) => {
            userLocationStore.remove(payload.userId)
        },
    },
} as SocketSlice
